import React from 'react';
import { IconProps } from '.';

const SvgCircleLinkFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm.595 10.405c.682.683.689 1.85-.07 2.609l-1.66 1.66c-.76.76-1.927.753-2.61.07-.682-.682-.688-1.85.07-2.608l-1.06-1.06c-1.306 1.305-1.375 3.423-.07 4.729 1.306 1.305 3.424 1.236 4.73-.07l1.66-1.66c1.307-1.307 1.376-3.425.07-4.73l-1.06 1.06Zm4.21-4.21c-1.306-1.305-3.424-1.236-4.73.07l-1.66 1.66c-1.307 1.307-1.376 3.425-.07 4.73l1.06-1.06c-.682-.683-.689-1.85.07-2.609l1.66-1.66c.76-.76 1.927-.753 2.61-.07.682.682.688 1.85-.07 2.608l1.06 1.06c1.306-1.305 1.375-3.423.07-4.729Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCircleLinkFill;
